(function () {
  "use strict";

  if (customElements.get("press-component")) return;

  customElements.define(
    "press-component",
    class extends HTMLElement {
      constructor() {
        super();

        this.slider = this.querySelector("[data-press-items]");
        this.sliderNav = this.querySelector("[data-logo-slider]");

        this.resizeEvent = () => this.refresh();
        this.loadEvent = () => this.refresh();

        this.mainSlider = null;
        this.navSlider = null;
      }

      connectedCallback() {
        if (!this.slider || !this.sliderNav) return;
        if (!window.theme || !window.theme.Flickity) return;

        this.init();

        document.addEventListener(
          "theme:resize:width",
          this.resizeEvent
        );

        window.addEventListener(
          "resize",
          this.resizeEvent
        );

        window.addEventListener(
          "load",
          this.loadEvent,
          { once: true }
        );

        this.querySelectorAll("img").forEach((img) => {
          if (!img.complete) {
            img.addEventListener(
              "load",
              this.loadEvent,
              { once: true }
            );
          }
        });

        setTimeout(() => this.refresh(), 300);
        setTimeout(() => this.refresh(), 800);
      }

      init() {
        const Flickity = window.theme.Flickity;

        const oldMain =
          Flickity.data(this.slider) || null;

        const oldNav =
          Flickity.data(this.sliderNav) || null;

        if (oldMain) oldMain.destroy();
        if (oldNav) oldNav.destroy();

        const duration =
          parseInt(this.dataset.duration, 10) || 4000;

        const autoplay =
          this.dataset.autoplay === "true"
            ? duration
            : false;

        /*
         * Ana metin sliderı
         */
        this.mainSlider = new Flickity(
          this.slider,
          {
            fade: true,
            wrapAround: true,
            adaptiveHeight: false,
            prevNextButtons: false,
            pageDots: false,
            autoPlay: autoplay,
          }
        );

        /*
         * Logo sliderı
         *
         * Önemli:
         * wrapAround / contain gibi ayarları
         * SONRADAN değiştirmiyoruz.
         */
        this.navSlider = new Flickity(
          this.sliderNav,
          {
            draggable: true,
            wrapAround: true,
            contain: false,
            imagesLoaded: true,
            asNavFor: this.slider,
            prevNextButtons: false,
            adaptiveHeight: false,
            pageDots: true,
          }
        );

        if (
          typeof window.theme.flickitySmoothScrolling ===
          "function"
        ) {
          window.theme.flickitySmoothScrolling(
            this.slider
          );

          window.theme.flickitySmoothScrolling(
            this.sliderNav
          );
        }

        this.navSlider.on(
          "change",
          (index) => {
            if (!this.mainSlider) return;

            this.mainSlider.selectCell(index);
          }
        );

        this.mainSlider.on(
          "change",
          (index) => {
            this.mainSlider.cells.forEach(
              (cell, cellIndex) => {
                cell.element
                  .querySelectorAll("a, button")
                  .forEach((element) => {
                    element.setAttribute(
                      "tabindex",
                      cellIndex === index
                        ? "0"
                        : "-1"
                    );
                  });
              }
            );
          }
        );

        this.querySelectorAll(
          "[data-logo-slide]"
        ).forEach((logo) => {
          if (
            logo.dataset.pressKeyboardReady ===
            "true"
          ) {
            return;
          }

          logo.dataset.pressKeyboardReady = "true";

          logo.addEventListener(
            "keyup",
            (event) => {
              const keys =
                window.theme.keyboardKeys || {};

              if (
                event.code === keys.ENTER ||
                event.code === keys.NUMPADENTER ||
                event.code === keys.SPACE
              ) {
                const index = Number(
                  logo.getAttribute(
                    "data-logo-index"
                  )
                );

                this.mainSlider.selectCell(index);
              }
            }
          );
        });

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.refresh();
          });
        });
      }

      refresh() {
        if (!this.mainSlider || !this.navSlider) {
          return;
        }

        const index =
          Number.isInteger(
            this.mainSlider.selectedIndex
          )
            ? this.mainSlider.selectedIndex
            : 0;

        this.mainSlider.resize();
        this.navSlider.resize();

        if (
          typeof this.mainSlider.reposition ===
          "function"
        ) {
          this.mainSlider.reposition();
        }

        if (
          typeof this.navSlider.reposition ===
          "function"
        ) {
          this.navSlider.reposition();
        }

        this.mainSlider.select(
          index,
          false,
          true
        );

        this.navSlider.select(
          index,
          false,
          true
        );
      }

      disconnectedCallback() {
        document.removeEventListener(
          "theme:resize:width",
          this.resizeEvent
        );

        window.removeEventListener(
          "resize",
          this.resizeEvent
        );

        window.removeEventListener(
          "load",
          this.loadEvent
        );

        this.querySelectorAll("img").forEach(
          (img) => {
            img.removeEventListener(
              "load",
              this.loadEvent
            );
          }
        );

        if (
          this.mainSlider &&
          typeof this.mainSlider.destroy ===
            "function"
        ) {
          this.mainSlider.destroy();
        }

        if (
          this.navSlider &&
          typeof this.navSlider.destroy ===
            "function"
        ) {
          this.navSlider.destroy();
        }

        this.mainSlider = null;
        this.navSlider = null;
      }
    }
  );
})();